

/**
 * flatten PDF => AV-Vertrag
 * pdf-lib
 * https://github.com/Hopding/pdf-lib#documentation
 */
import flattenPdf from "./chunk/flattenForm.js";

const form = document.querySelector('#pda_form');

form.onsubmit = function (event) {
  event.preventDefault();

  const formData = Object.fromEntries(new FormData(form).entries());

  flattenPdf(formData);
}


/**
 * MDC Textfield
 *
 */
import {MDCTextField} from '@material/textfield';

// const textField = new MDCTextField(document.querySelectorAll('.mdc-text-field'));
const textFields = [].map.call(document.querySelectorAll('.mdc-text-field'), function(el) {
  return new MDCTextField(el);
});



/**
 * MDC Checkbox
 *
 */
import {MDCFormField} from '@material/form-field';
import {MDCCheckbox} from '@material/checkbox';

const checkbox = new MDCCheckbox(document.querySelector('.mdc-checkbox'));
const formField = new MDCFormField(document.querySelector('.mdc-form-field'));
formField.input = checkbox;


/**
 * MDC Button
 *
 */
import {MDCRipple} from '@material/ripple';

const buttonRipple = new MDCRipple(document.querySelector('.mdc-button'));